import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import DatePicker from 'antd/lib/date-picker';
import moment from 'moment';
import Button from '../Button';
import { getWeekEndDayForDate } from '../../index';

const StyledDatePicker = styled(DatePicker)``;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  > * {
    margin: 0 0.5em;
  }
  > *:first-child {
    margin-left: 0;
  }
  > *:last-child {
    margin-right: 0;
  }
`;

const CustomWeekPicker = ({ endDate: endDateProp, onDateChange, loading = false }) => {
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    setEndDate(endDateProp);
  }, [endDateProp]);

  const getTargetDateForDirection = (currentDate, direction) => {
    let targetDate;
    if (direction === 'next') {
      targetDate = moment(currentDate).add(1, 'day');
    } else if (direction === 'prev') {
      targetDate = moment(currentDate).subtract(1, 'day');
    } else {
      // current or specific date
      targetDate = moment(currentDate).startOf('day');
    }

    const mapToMoment = { sun: 0, mon: 1, tue: 2, wed: 3, thu: 4, fri: 5, sat: 6 };

    // Scan for up to 14 days to find the correct week end day
    for (let i = 0; i < 14; i++) {
      const weDay = getWeekEndDayForDate(targetDate);
      const weDayIndex = mapToMoment[weDay];

      if (targetDate.day() === weDayIndex) {
        return targetDate;
      }

      if (direction === 'prev') {
        targetDate.subtract(1, 'day');
      } else {
        targetDate.add(1, 'day');
      }
    }
    return targetDate; // Fallback
  };

  const handleChangeOfWeekDate = momentDate => {
    const newEndDate = getTargetDateForDirection(momentDate, 'current');
    if (onDateChange) {
      onDateChange(newEndDate.format('YYYYMMDD'));
    }
  };

  const goToNextWeek = oldEndDate => {
    const newEndDate = getTargetDateForDirection(oldEndDate, 'next');
    onDateChange(newEndDate.format('YYYYMMDD'));
  };

  const goToPrevWeek = oldEndDate => {
    const newEndDate = getTargetDateForDirection(oldEndDate, 'prev');
    onDateChange(newEndDate.format('YYYYMMDD'));
  };

  const goToCurrentWeek = () => {
    const today = moment();
    const newEndDate = getTargetDateForDirection(today, 'current');
    onDateChange(newEndDate.format('YYYYMMDD'));
  };

  const endDateMoment = moment(endDate);
  return (
    <Wrapper className="flex-wrap gap-2">
      <div className="flex flex-row gap-2">
        <Button disabled={loading} icon="left" onClick={() => goToPrevWeek(endDateMoment)} />
        <Button disabled={loading} onClick={() => goToCurrentWeek(endDateMoment)}>
          Current Week
        </Button>
        <Button disabled={loading} icon="right" onClick={() => goToNextWeek(endDateMoment)} />
      </div>
      <StyledDatePicker
        disabled={loading}
        allowClear={false}
        format="MM/DD/YYYY"
        value={endDateMoment}
        onChange={handleChangeOfWeekDate}
        placeholder="Select Week"
      />
    </Wrapper>
  );
};

CustomWeekPicker.propTypes = {
  endDate: PropTypes.string,
  onDateChange: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default CustomWeekPicker;
